var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171275404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 153760",
    d: "M4.99453 2.31357C4.9678 1.83249 5.3507 1.42773 5.83252 1.42773H6.47567C6.95749 1.42773 7.34039 1.8325 7.31367 2.31358L7.06155 6.85161C7.03685 7.29636 6.669 7.64434 6.22356 7.64434H6.08463C5.6392 7.64434 5.27135 7.29636 5.24664 6.85161L4.99453 2.31357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 101",
    cx: 6.15248,
    cy: 9.54506,
    r: 0.863417,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage3);
export default __webpack_public_path__ + "static/media/page3.c9b8fc9db92a926fae43a78ead477e56.svg";
export { ForwardRef as ReactComponent };